import {bindable, customElement, inject} from 'aurelia-framework';
import Backend from "../backend";
import {ApiClient} from "../api-client";

@customElement('payment-notifications-component')
@inject(Element, Backend, ApiClient)
export class PaymentNotificationsComponent {
  element;
  backend;
  apiClient;

  @bindable() subscriptionId;

  constructor(element, backend, apiClient) {
    this.element = element;
    this.backend = backend;
    this.apiClient = apiClient;
  }

  attached() {
    this.backend.PaymentNotificationsQueryHandler_handle({subscriptionId: this.subscriptionId})
      .then(result => {
        this.subscriptionItems = result.subscriptionItems;
        this.isMissingPaymentMeans = result.isMissingPaymentMeans;
      })
      .catch(error => {
        // Mute because my-page can work fine without this component

        // Log to backend
        this.apiClient.frontendLog('error while loading payment status in payment-notifications-component: ' + JSON.stringify(error), error.stack);
      });
  }
}
